import { render, staticRenderFns } from "./EditProductDetailsPopup.vue?vue&type=template&id=0f47f2dd&scoped=true"
import script from "./EditProductDetailsPopup.vue?vue&type=script&lang=js"
export * from "./EditProductDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./EditProductDetailsPopup.vue?vue&type=style&index=0&id=0f47f2dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f47f2dd",
  null
  
)

export default component.exports